import Image from "next/image";
import QRCode from "react-qr-code";

import { Receipt } from "@/types/receipt";
import { translate, formatDate, formatPercentage } from "@/utils/formatters";

import styles from "./DiscountsPopup.module.css";
import barcodeStyles from "./barcode.module.css";

interface DiscountsPopupProps {
  receipt: Receipt;
  lang: string;
  discountBarcodeImages: string[];
  closeButton?: React.ReactNode;
}

export const DiscountsPopup = ({
  receipt,
  lang,
  discountBarcodeImages: discounts,
  closeButton,
}: DiscountsPopupProps) => {


  return (
    <>
      <div className="box head">
        <h4>{translate(lang, "Kuponger", "Coupons")}</h4>
        {closeButton}
      </div>

      <div className="box">
        {receipt.extended_receipt_logic?.discounts?.map((discount, index) => (
          <div
            key={`discount-${discount.description}-${discount.amount}-${discount.percentage}-${index}`}
            className={styles.discountItem}
          >
            {discount.title && (
              <h5 className={styles.discountTitle}>
                {discount.title}
              </h5>
            )}

            {discount.description && (
              <p className={styles.discountDescription}>{discount.description}</p>
            )}

            {!!discount.related_articles && (
              <div className={styles.section}>
                <h5>
                  {translate(lang, "Relaterte artikler", "Related articles")}
                </h5>
                {discount.related_articles.map((article, artIndex) => (
                  <div
                    key={`article-${article.art_number}-${article.art_name}-${artIndex}`}
                    className={styles.section}
                  >
                    <p>
                      <strong>{article.art_number}</strong> - {article.art_name}
                    </p>
                    {article.art_description && (
                      <p className={styles.articleDescription}>
                        {article.art_description}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            )}

            {discount.amount != null && (
              <div className={styles.section}>
                <h5>{translate(lang, "Rabattsum", "Discount amount: ")}</h5>
                <p className={styles.smallValue}>{discount.amount}</p>
              </div>
            )}

            {discount.percentage != null && (
              <div className={styles.section}>
                <h5>
                  {translate(lang, "Rabattprosent ", "Discount percentage: ")}
                </h5>
                <p className={styles.smallValue}>
                  {formatPercentage(discount.percentage)}
                </p>
              </div>
            )}

            {discount.expired_at && (
              <div className={styles.section}>
                <h5>{translate(lang, "Utløpsdato", "Expiration date: ")}</h5>
                <p className={styles.smallValue}>
                  {formatDate(discount.expired_at, "no-NO", false)}
                </p>
              </div>
            )}

            {/* Bar / QR code */}
            {discount.barcode?.value && (
              <div>
                <div className={styles.barcodeCenter}>
                  <div>
                    {discount.barcode.encoding === "qr" ? (
                      <QRCode
                        value={discount.barcode.value}
                        size={140}
                        level="H"
                        title="Discount QR code"
                      />
                    ) : (
                      <Image
                        src={discounts[index]}
                        alt="Barcode"
                        width={260}
                        height={100}
                        className={barcodeStyles.barcodeImage}
                      />
                    )}
                  </div>
                  {discount.barcode.display_value && (
                    <p className={barcodeStyles.barcodeDisplayValue}>
                      {discount.barcode.display_value}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
